<script setup lang="ts">
import { computed } from 'vue';
import InlineSvg from 'vue-inline-svg';
import { type Color, getColorValue } from '@global-types/colors';

interface IconProps {
  svg: string;
  title?: string;
  width?: string | number;
  height?: string | number;
  fill?: Color | 'current' | 'none';
  stroke?: Color | 'current';
  customClass?: string;
}

const props = defineProps<IconProps>();

const colorValue = computed<string | undefined>(() => {
  if (props.fill === undefined) {
    return undefined;
  }

  if (props.fill === 'current') {
    return 'currentColor';
  }

  if (props.fill === 'none') {
    return 'none';
  }

  return getColorValue(props.fill);
});

const strokeColorValue = computed<string | undefined>(() => {
  if (props.stroke === undefined) {
    return undefined;
  }

  if (props.stroke === 'current') {
    return 'currentColor';
  }

  return getColorValue(props.stroke);
});
</script>

<template>
  <InlineSvg
    :src="svg"
    :class="customClass"
    :title="title"
    :width="width"
    :height="height"
    :fill="colorValue"
    :style="stroke ? { color: strokeColorValue } : undefined"
  />
</template>
